import axios from "axios";
import { request } from "@/utils/request";
//查询数据列表 分类 姓名或号码
export function select_p(form) {
  return request({
    url: `/foodExpo/select`,
    method: "POST",
    data: {
      form,
    },
  });
}

//增加
export function add_p(form) {
  return request({
    url: `/foodExpo/add`,
    method: "POST",
    data: { form },
  });
}

//删除
export function delete_p(data) {
  return request({
    url: `/foodExpo/delete`,
    method: "POST",
    data,
  });
}

//修改
export function updata_p(form) {
  return request({
    url: `/foodExpo/update`,
    method: "POST",
    data: { form },
  });
}

//公司名精确查询数据列表--------用户去重复提醒的 还没写
export function select_fairstr(fairTitle) {
  return request({
    url: `/foodExpo/selectcompany`,
    method: "POST",
    data: {
      fairTitle,
    },
    headers: {
      token: localStorage.getItem("token"),
    },
  });
}
